import cx from 'classnames'
import { Icon } from 'components/common/Icon'
import { MouseEventHandler } from 'react'

const colors = {
  black: 'bg-cool-800 text-cool-150',
  green: 'bg-success-light text-cool-150',
  'light-green': 'bg-[#00B78F] text-cool-150',
  'success-light':
    'bg-success-lightest text-success-default [&_svg]:!text-success-default font-medium',
  primary: 'bg-primary-default text-cool-150',
  red: 'bg-chili-800 text-cool-150',
  yellow: 'bg-warning-light text-cool-800 border border-warning-default',
  transparent:
    'bg-transparent text-cool-700 border-solid border border-cool-400',
  'transparent-solid':
    'bg-transparent text-cool-800 border border-cool-400 [&_svg]:!text-cool-800 font-medium hover:border-cool-900',
  'red-transparent':
    'bg-danger-light border border-opacity-25 border-danger-dark text-cool-800',
  none: '',
  'light-purple':
    'bg-purple-50 text-purple-700 font-medium [&_svg]:!text-purple-700 group-hover:bg-purple-700 group-hover:text-cool-50 group-hover:[&_svg]:text-cool-50',
} as const

const sizes = {
  XS: 'text-2xs py-0.5',
  S: 'text-xs py-1',
  M: 'text-sm py-1',
}

interface Props {
  children?: React.ReactNode
  className?: string
  icon?: string | null
  iconFilled?: boolean
  color?: keyof typeof colors
  size?: keyof typeof sizes
  iconSize?: number
  iconPosition?: 'left' | 'right'
  iconClassName?: string
  onClick?: MouseEventHandler<HTMLDivElement>
}

export const Tag = ({
  children,
  className,
  icon = 'check',
  iconFilled = false,
  color = 'black',
  size = 'M',
  iconSize,
  iconPosition = 'left',
  iconClassName,
  onClick,
}: Props) => {
  return (
    <div
      className={cx(
        `inline-flex h-auto items-center justify-center rounded-full transition-all duration-100
        ${colors[color]}
        ${sizes[size]}
        ${className}
      `,
        {
          'pl-2': icon && iconPosition === 'left',
          'pr-3': icon && iconPosition === 'left',
          'pr-2': icon && iconPosition === 'right',
          'pl-3': icon && iconPosition === 'right',
          'px-2.5': !icon,
        }
      )}
      role='button'
      onClick={onClick}
    >
      {icon && iconPosition === 'left' && (
        <Icon
          name={icon}
          size={iconSize}
          filled={iconFilled}
          className={cx(`text-cool-150 ${iconClassName}`, {
            'mr-1': size === 'XS' || size === 'S',
            'mr-2': size !== 'XS' && size !== 'S',
          })}
        />
      )}

      {children}

      {icon && iconPosition === 'right' && (
        <Icon
          name={icon}
          size={iconSize}
          filled={iconFilled}
          className={cx(`text-cool-150 ${iconClassName}`, {
            'ml-1': size === 'XS' || size === 'S',
            'ml-2': size !== 'XS' && size !== 'S',
          })}
        />
      )}
    </div>
  )
}
